export let DomainConnectedStatus = /*#__PURE__*/function (DomainConnectedStatus) {
  DomainConnectedStatus["CAN_BE_CONNECTED"] = "CAN_BE_CONNECTED";
  DomainConnectedStatus["ALREADY_CONNECTED_TO_ANOTHER_SITE"] = "ALREADY_CONNECTED_TO_ANOTHER_SITE";
  DomainConnectedStatus["ALREADY_CONNECTED"] = "ALREADY_CONNECTED";
  DomainConnectedStatus["CREATE_CONNECT"] = "CREATE_CONNECT";
  DomainConnectedStatus["NEED_MORE_TIME_TO_VERIFY"] = "NEED_MORE_TIME_TO_VERIFY";
  return DomainConnectedStatus;
}({});
//# sourceMappingURL=connectedDomainSetupConfig.js.map